<woa-modal-page-layout [title]="'woa.heading.phone.title'">
    @if ((error() | translate)?.trim()) {
        <woa-content-message [level]="MessageLevel.WARNING" [text]="error()"
                             [translationParams]="{
                                 'expectedCountryCode': configurationModel.app()?.expectedCountryCode,
                                 'suppliedMobilePhone': suppliedMobilePhone()
                             }"></woa-content-message>
    }
    <woa-content-message [level]="MessageLevel.INFO" [text]="instructions()"></woa-content-message>
    <woa-form (onSubmit)="confirmPhone()">
        <woa-phone-number-field [(ngModel)]="confirmedMobilePhone" name="confirmedMobilePhone"
                                [label]="'woa.label.common.mobile'"
                                [required]="orderingContextModel.requirePhoneNumber()"
                                woa-sms-phone-number></woa-phone-number-field>
    </woa-form>
    <woa-button woa-page-footer-control [label]="'woa.button.phone.confirm'" (onActivate)="form().submit()"></woa-button>
</woa-modal-page-layout>
